/**
 * 边线颜色变化
 */
import fvAnimation from "./fvAnimation"
export default class fvLineColor extends fvAnimation {
    constructor(shape){
        super(shape,"fvLineColor");
        this.colorOldBorderColor = this.shape.borderColor;
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }
    async run(canvas,value){
        //if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        for(var i in this.changeColor){
            if(this.changeColor[i].Twinkel == true){
                if(this.shape.borderColor == this.colorOldBorderColor){
                    this.shape.borderColor = this.changeColor[i].TwinkelColor ;
                }
                else{
                    this.shape.borderColor = this.colorOldBorderColor ;
                }
            }else{
                if(size >= this.changeColor[i].MinValue && size <= this.changeColor[i].MaxValue){
                    this.shape.borderColor = this.changeColor[i].FlashingColor;
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvLineColor.js